import { render, staticRenderFns } from "./SplitTransaction.vue?vue&type=template&id=b085f070&scoped=true"
import script from "./SplitTransaction.vue?vue&type=script&lang=js"
export * from "./SplitTransaction.vue?vue&type=script&lang=js"
import style0 from "./SplitTransaction.vue?vue&type=style&index=0&id=b085f070&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b085f070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b085f070')) {
      api.createRecord('b085f070', component.options)
    } else {
      api.reload('b085f070', component.options)
    }
    module.hot.accept("./SplitTransaction.vue?vue&type=template&id=b085f070&scoped=true", function () {
      api.rerender('b085f070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/service-provider-tools/components/SplitTransaction.vue"
export default component.exports